import { render, staticRenderFns } from "./UsageTermsPreview.vue?vue&type=template&id=6ccd8d8f&scoped=true"
import script from "./UsageTermsPreview.vue?vue&type=script&lang=js"
export * from "./UsageTermsPreview.vue?vue&type=script&lang=js"
import style0 from "./UsageTermsPreview.vue?vue&type=style&index=0&id=6ccd8d8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccd8d8f",
  null
  
)

export default component.exports